import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  absentList: [], 
  absentArr: [],
  absentArray: [],
  absentID: '',
  selectedAbsent: null,
  selectedEmployee: null,
  selectedPolicy: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.absentList = [];
    state.absentArr = [];
    state.absentArray = [];
    state.absentID = "";
    state.selectedAbsent = null;
    state.selectedEmployee = null;
    state.selectedPolicy = null;
    state.isEditing = false;
  },
  SET_SELECTED_ABSENTEEISM(state, Absents) {
    state.selectedAbsent = Absents;
    state.isEditing = true;
  },
  LIST_ABSENTEEISM(state, Absents) {
    state.absentList = Absents;
  },
  ABSENTEEISM_ARRAY(state, Absents){
    state.absentArray = Absents;
  },
  SET_SELECTED_POLICY(state, Absents) {
    state.selectedPolicy = Absents;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createEmployeeAbsenteeism({ commit,state }, formData) {
    return axios.post('api/v1/create-employee-absenteeism/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchEmployeeAbsenteeisms({ commit,state }, formData) {
    state.absentArr = [];
    axios.post(`api/v1/get-employee-absenteeisms/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.absentArr.push((response.data[i].absenteeism.name + " - " + response.data[i].employee.employee_name +" ("+ response.data[i].employee.staff_number +")"));
      }
      commit('LIST_ABSENTEEISM', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchEmployeeAbsenteeism({ commit,state }, formData) {
    axios.post(`api/v1/get-employee-absenteeisms/`,formData)
    .then((response)=>{
      state.selectedAbsent = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      const selectedPolicy = response.data.absenteeism.name;
      commit('SET_SELECTED_ABSENTEEISM',response.data);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);
      commit('SET_SELECTED_POLICY', selectedPolicy);

    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedEmployeeAbsenteeism({ commit, state }, option){
    const selectedAbsent = state.absentList.find(absents => (absents.absenteeism.name + " - " + absents.employee.employee_name +" ("+ absents.employee.staff_number +")") === option);
    if (selectedAbsent) {
        state.absentID = selectedAbsent.employee_absenteeism_id;
        state.absentArray = [...state.absentArray, selectedAbsent];
    }
    commit('ABSENTEEISM_ARRAY', state.absentArray);
      
  },

  async updateEmployeeAbsenteeism({ commit,state }, formData) {
    return axios.put(`api/v1/update-employee-absenteeism/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteEmployeeAbsenteeism({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Absenteeism?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Absenteeism!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-employee-absenteeism/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Absenteeism removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Absenteeism",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Absenteeism has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  